<app-breadcrumb></app-breadcrumb>
<div class="row m-b-16">
    @for(topcard of topcards; track topcard) {

    <div class="col-lg-2 col-sm-4 col-6">
        <mat-card class="shadow-none text-center bg-light-primary card-hover shadow-none cursor-pointer"
            (click)="selectTab(topcard)" [class.active-tab]="selectedTab.id === topcard.id">
            <mat-card-content class="p-20">
                <img [src]="topcard.img" alt="{{ topcard.title }}" width="100" height="100" />
                <h4 class="mat-subtitle-2 f-w-600 text-{{ topcard.color }}">
                    {{ topcard.title| translate }}
                </h4>
            </mat-card-content>
        </mat-card>

    </div>
    }
</div>